import { Cidade } from 'service/api'
import { z } from 'zod'

export type TFuncionario =
    | {
          id: number
          matricula: number
          nome: string
          cargo: string
          pis: string
          cpf: string
          dtAdmissao: string
          dataAbnt: string
          reconhecimentoFacial?: number
          erro?: boolean
          importado?: boolean
      }
    | undefined

export type State = {
    funcionariosImportar: TFuncionario[] | undefined
    erro: string | null
    linhaInicial: number
    isLoading: boolean
    Cidade?: Cidade
}

type FunctionImports = (
    value: TFuncionario[] | undefined,
) => TFuncionario[] | undefined

type SetterImports = (
    value: FunctionImports | TFuncionario[] | undefined,
) => void

type FunctionErro = (value: string | null) => string | null
type SetterError = (value: FunctionErro | string | null) => void

type Action = {
    setImports: SetterImports
    setErro: SetterError
    setLinhaInicial: (value: number) => void
    setIsLoading: (value: boolean) => void
    setCidade: (value: Cidade) => void
    reset: () => void
}

export const ImportacaoSchema = z.object({
    regraCalculo: z.string().min(1, 'Selecione uma regra de cálculo'),
    tabelaHorarioId: z.string().optional(),
    Cidade: z
        .object(
            {
                ibge: z.coerce.number(),
            },
            {
                invalid_type_error: 'Selecione uma cidade',
            },
        )
        .nullish(),
})

export type Store = {
    state: State
    actions: Action
}
